import "./SubmitAction.css";
import { loading, rightArrow } from "@simplybusiness/icons";
import { Button, Icon } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";
import { useCallback, useEffect, useRef, useState } from "react";

export type SubmitActionProps = {
  isDisabled?: boolean;
  children?: React.ReactNode;
  buttonLabel?: string;
  onSubmit?: () => void;
  errors?: Record<string, unknown>;
};

export const SubmitAction = ({
  children,
  isDisabled,
  buttonLabel = "Continue",
  onSubmit,
  errors,
}: SubmitActionProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const handleSubmit = useCallback(() => {
    setIsLoading(true);
    onSubmit?.();
  }, [onSubmit]);

  // Reset loading state when validation errors occur
  useEffect(() => {
    if (isLoading && errors && Object.keys(errors).length > 0) {
      setIsLoading(false);
    }
  }, [errors, isLoading]);

  const classes = classNames("mobius-submit-action", {
    "mobius-submit-action--padded": !!children,
  });

  return (
    <div id="mobius-submit-action" className={classes}>
      <div>{children}</div>
      <Button
        ref={buttonRef}
        onClick={handleSubmit}
        isDisabled={isDisabled}
        type="submit"
      >
        {buttonLabel}{" "}
        {isLoading ? (
          <Icon
            icon={loading}
            spin
            fixedWidth
            title="Processing your request"
          />
        ) : (
          <Icon icon={rightArrow} fixedWidth title="Submit form" />
        )}
      </Button>
    </div>
  );
};
